// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3ESdg","large":"styles_large__-E8Cj"};